// extracted by mini-css-extract-plugin
export default {"container":"DriversClubLogo_container__YFCD6","logo":"DriversClubLogo_logo__bPtwA","verticalBar":"DriversClubLogo_verticalBar__ZBukt","wordMark":"DriversClubLogo_wordMark__Mn3t-"};